import { PaidFeedbackEligibilityResponse } from '@/pages/api/paid-feedback/eligibility';
import { useQuery } from '@tanstack/react-query';

import { routes } from '@/utils/routes';

import { fetcherWithJwt, getFullURL } from '../utils/fetcher';

export const paidFeedbackEligibilityQueryKey = (walletAddress: string | undefined) =>
  ['paid-feedback-eligibility', walletAddress] as const;

/**
 * Checks if a wallet is eligible for the paid-feedback program and whether
 * they've already submitted.
 *
 * @param walletAddress - User's wallet address
 * @returns PaidFeedbackEligibilityResponse with isEligible and hasSubmitted booleans
 */
export const usePaidFeedbackEligibility = (walletAddress: string | undefined) => {
  const normalizedAddress = walletAddress?.toLowerCase();

  return useQuery<PaidFeedbackEligibilityResponse, Error>({
    queryKey: paidFeedbackEligibilityQueryKey(normalizedAddress),
    queryFn: () =>
      fetcherWithJwt(
        getFullURL(
          `${routes.api.PAID_FEEDBACK_ELIGIBILITY}?walletAddress=${encodeURIComponent(normalizedAddress!)}`,
        ),
      ),
    enabled: !!normalizedAddress,
    refetchOnReconnect: false,
  });
};
